// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, insertItem, patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { ContractsService } from '../../services/contracts.service';
import { CreatedContractByWS, UpdatedContractByWS } from '../contract-manage/contract-manage.actions';
import {
  ClearScrollPositionContractList,
  GetContractList,
  GetContractListError,
  GetContractListSuccess,
  SetLastOpenedContractId,
  UpdateScrollPositionContractList
} from './contract-list.actions';
import { CONTRACT_LIST_STATE_DEFAULT, ContractListStateModel } from './contract-list.model';


@State({ name: 'ContractList', defaults: CONTRACT_LIST_STATE_DEFAULT })
@Injectable()
export class ContractListState {

  @Selector()
  static contractList(state: ContractListStateModel): ContractListStateModel['contractList'] {
    return state.contractList;
  }

  @Selector()
  static loadContractListStatus(state: ContractListStateModel): ContractListStateModel['loadContractListStatus'] {
    return state.loadContractListStatus;
  }

  @Selector()
  static lastOpenedDocId(state: ContractListStateModel): ContractListStateModel['lastOpenedDocId'] {
    return state.lastOpenedDocId;
  }

  @Selector()
  static scrollPosition(state: ContractListStateModel): ContractListStateModel['scrollPosition'] {
    return state.scrollPosition;
  }

  constructor(private contractsService: ContractsService) {
  }

  @Action(GetContractList)
  getContractList(ctx: StateContext<ContractListStateModel>, { filter, lazy }: GetContractList): void {
    if (lazy) {
      const next = ctx.getState().contractList?.links?.next;
      if (next) {
        ctx.patchState({
          loadContractListStatus: PROGRESS_STATUSES.IN_PROGRESS
        });
        this.contractsService.getContractListLazy(next).subscribe({
          next: res => ctx.dispatch(new GetContractListSuccess(res, lazy)),
          error: error => ctx.dispatch(new GetContractListError(error))
        });
      }
    } else {
      ctx.patchState({
        loadContractListStatus: PROGRESS_STATUSES.IN_PROGRESS
      });
      this.contractsService.getContractList(filter).subscribe({
        next: res => ctx.dispatch(new GetContractListSuccess(res, lazy)),
        error: error => ctx.dispatch(new GetContractListError(error))
      });
    }
  }

  @Action(GetContractListSuccess)
  getContractListSuccess(ctx: StateContext<ContractListStateModel>, {
    contractList,
    lazy
  }: GetContractListSuccess): void {
    ctx.patchState({
      loadContractListStatus: PROGRESS_STATUSES.SUCCESS
    });
    if (lazy) {
      ctx.setState(patch({
        contractList: patch({
          data: append([...contractList.data]),
          links: contractList.links,
          meta: contractList.meta
        })
      }));
    } else {
      ctx.patchState({
        contractList
      });

    }
  }

  @Action(GetContractListError)
  getContractListError(ctx: StateContext<ContractListStateModel>, { error }: GetContractListError): void {
    ctx.patchState({
      loadContractListStatus: PROGRESS_STATUSES.FAIL
    });
  }


  @Action(ClearScrollPositionContractList)
  clearScrollPositionContractList(ctx: StateContext<ContractListStateModel>): void {
    ctx.patchState({ scrollPosition: 0 });
  }

  @Action(UpdateScrollPositionContractList)
  updateScrollPosition(ctx: StateContext<ContractListStateModel>, { position }: UpdateScrollPositionContractList): void {
    ctx.patchState({ scrollPosition: position });
  }

  @Action(SetLastOpenedContractId)
  setLastOpenedDocId(ctx: StateContext<ContractListStateModel>, { contractId }: SetLastOpenedContractId): void {
    ctx.patchState({ lastOpenedDocId: contractId });
  }


  @Action(UpdatedContractByWS)
  updatedOrderBuWS(ctx: StateContext<ContractListStateModel>, { contract }: UpdatedContractByWS): void {

    ctx.setState(patch({
      contractList: patch({
        data: updateItem(o => o?.id === contract.id, contract)
      })
    }));
  }

  @Action(CreatedContractByWS)
  createdOrderByWS(ctx: StateContext<ContractListStateModel>, { contract }: CreatedContractByWS): void {
    ctx.setState(patch({
      contractList: patch({
        data: insertItem(contract, 0),
        meta: patch({
          totalItems: ctx.getState().contractList?.meta?.totalItems + 1
        })
      })
    }));
  }
}


